import { ButtonDefault } from "../../components/buttons/button-default/ButtonDefault";
import { buttonVariants } from "../../components/buttons/button-default/buttonVariants";
import { t } from "../../i18n/translate";
import "./home.css";

type HomeProps = {
  onStart: () => void;
};

export function Home({ onStart }: HomeProps) {
  return (
    <div id="homePage">
      <div className="button-container">
        <ButtonDefault
          variant={buttonVariants.ghost}
          onClick={onStart}
        >
          {t("entrar")}
        </ButtonDefault>
      </div>
    </div>
  );
}
